module.exports = __webpack_public_path__ + "img/pic_usa_08.6b959bb9.jpg";